import { render, staticRenderFns } from "./schedule-class-form.vue?vue&type=template&id=493cbe08"
import script from "./schedule-class-form.vue?vue&type=script&lang=js"
export * from "./schedule-class-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports